import ApontamentoEntidadeEvent from "@/domain/events/apontamentoEntidade.event";
import {reactive} from "vue";
import type {ComissaoVm} from "@/domain/type/comissao.type";

class ComissaoEvents {

    apontamentoEvent = new ApontamentoEntidadeEvent()

    listenerComissaoGravada = reactive({value: {comissaoId: ''}})
    listenerComissaoAdicionada = reactive({value: {comissaoId: ''}})
    listenerComissaoInformacoesAltera = reactive({value: {comissao: {} as ComissaoVm}})
    listenerComissaoAlterada = reactive({value: {comissaoId: ''}})
    listenerComissaoRemovida = reactive({value: {comissaoId: ''}})
    listenerComissaoRemovidaCondicao = reactive({value: {comissaoId: ''}})
    listenerCancelarAlteracao = reactive({value: {comissaoId: ''}})

    emitComissaoGravada(comissaoId: string) {
        this.listenerComissaoGravada.value = {comissaoId: comissaoId}
    }

    emitComissaoAdicionada(comissaoId: string) {
        this.listenerComissaoAdicionada.value = {comissaoId: comissaoId}
    }

    emitComissaoInformacoesAltera(comissao: ComissaoVm) {
        this.listenerComissaoInformacoesAltera.value = {comissao: comissao}
    }

    emitComissaoAlterada(comissaoId: string) {
        this.listenerComissaoAlterada.value = {comissaoId: comissaoId}
    }

    emitComissaoRemovida(comissaoId: string) {
        this.listenerComissaoRemovida.value = {comissaoId: comissaoId}
    } 
    
    emitComissaoRemovidaCondicao(comissaoId: string) {
        this.listenerComissaoRemovidaCondicao.value = {comissaoId: comissaoId}
    } 
    
    emitlistenerCancelarAlteracao(comissaoId: string) {
        this.listenerCancelarAlteracao.value = {comissaoId: comissaoId}
    }
}

export default ComissaoEvents;